import { createSlice } from '@reduxjs/toolkit';
import CircularBuffer from '../common/util/CircularBuffer';

const { reducer, actions } = createSlice({
  name: 'session',
  initialState: {
    server: null,
    user: null,
    revenda: null,
    socket: null,
    includeLogs: false,
    logs: [],
    positions: {},
    history: {},
    printing: false, // Adicionei esta propriedade
  },
  reducers: {
    // Adicionei esta ação para controlar o estado de impressão
    setPrinting(state, action) {
      state.printing = action.payload;
    },
    updateServer(state, action) {
      state.server = action.payload;
    },
    updateUser(state, action) {
      state.user = action.payload;
    },
    updateSocket(state, action) {
      state.socket = action.payload;
    },
    enableLogs(state, action) {
      state.includeLogs = action.payload;
      if (!action.payload) {
        state.logs = [];
      }
    },
    updateLogs(state, action) {
      state.logs.push(...action.payload);
    },
    // 2ECOMP: Atualiza positions com suporte a live routes (CircularBuffer O(1))
    updatePositions(state, action) {
      // 2ECOMP DEBUG: Log positions being processed by Redux
      // console.log(`[Redux] Processing ${action.payload.length} positions`);

      // Null safety: user/server may be null during logout
      const liveRoutes = state.user?.attributes?.mapLiveRoutes || state.server?.attributes?.mapLiveRoutes || 'none';
      const liveRoutesLimit = state.user?.attributes?.['web.liveRouteLength'] || state.server?.attributes?.['web.liveRouteLength'] || 10;

      // Early return se não há live routes - limpa histórico uma vez
      if (liveRoutes === 'none') {
        if (Object.keys(state.history).length > 0) {
          state.history = {};
        }
        // Atualiza todas as positions (igual ao Traccar oficial)
        action.payload.forEach((position) => {
          state.positions[position.deviceId] = position;
        });
        return;
      }

      // Processa posições com CircularBuffer O(1) real
      action.payload.forEach((position) => {
        state.positions[position.deviceId] = position;

        // 2ECOMP: Validar coordenadas antes de adicionar ao histórico
        // Coordenadas inválidas (null, undefined, NaN) causam erro no MapLibre
        const lng = position.longitude;
        const lat = position.latitude;
        if (!Number.isFinite(lng) || !Number.isFinite(lat)) {
          return; // Skip posições com coordenadas inválidas
        }

        // Inicializa CircularBuffer se não existe
        if (!state.history[position.deviceId]) {
          state.history[position.deviceId] = CircularBuffer.create(liveRoutesLimit);
        }
        const route = state.history[position.deviceId];
        const last = CircularBuffer.last(route);

        // Só adiciona ao histórico se coordenadas diferentes (otimização segura)
        if (!last || last[0] !== lng || last[1] !== lat) {
          CircularBuffer.push(route, [lng, lat]);
        }
      });
    },
    setRevenda(state, action) {
      state.revenda = action.payload;
    },
  },
});

export { actions as sessionActions };
export { reducer as sessionReducer };